import { Button, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function SearchCriteria(props) {
  const { filedAt, query } = props;
  return (
    
    <InputGroup.Append style={{display: "inline"}}>
      <span className="mb-3">
        {/* <Button variant="default" as={Link}  active={query === ""} to={`search?q=&filedAt=${filedAt}`} className="btn btn-outline-deal-style px-2 mr-1 flow-control" style={{borderRadius: "20px"}}> */}
        <Button variant="default" as={Link}  active={query === ""} to={`optimizedSearch`} className="btn btn-outline-deal-style px-2 mr-1 flow-control" style={{borderRadius: "20px"}}>
          All Filings
        </Button>

        {/* <Button variant="default" as={Link} active={query === 'Loan Document'} to={`search?q=${encodeURIComponent('Loan Document')}&filedAt=${filedAt}`} className="btn btn-outline-deal-style px-2 flow-control" style={{borderRadius: "20px"}}> */}
        <Button variant="default" as={Link} active={query === 'Loan Document'} to={`client`} className="btn btn-outline-deal-style px-2 flow-control" style={{borderRadius: "20px"}}>
          Loan Docs
        </Button>{" "}

        {/* <Button variant="success" as={Link} active={query === '"Termination of a Material" OR "Entry into a Material"'} to={`search?q=${encodeURIComponent('"Termination of a Material" OR "Entry into a Material"')}&filedAt=${filedAt}`} className="px-2">
          Summary Docs
        </Button>    Maybe used for future*/}
      </span>
    </InputGroup.Append>
  );
}
